import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useUser } from '../../../context/UserContext';

export function portfolioAuthHeaders(userId) {
  return userId ? { 'X-User-Id': userId } : {};
}

/**
 * Portfolio APIs require a real authenticated user id (UUID from /user/me).
 * Use requireAuth() before save/list mutations; pass userId into service calls.
 */
export function usePortfolioUser() {
  const { userData, loading } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const userId = userData?.id || null;
  const isAuthenticated = Boolean(userId);

  const requireAuth = useCallback(
    (promptMessage = 'Please log in to manage your portfolio') => {
      if (loading) {
        return { ok: false, pending: true, userId: null };
      }
      if (!userId) {
        message.warning(promptMessage);
        navigate('/login', { state: { from: location.pathname }, replace: false });
        return { ok: false, pending: false, userId: null };
      }
      return { ok: true, pending: false, userId };
    },
    [loading, userId, navigate, location.pathname]
  );

  const authHeaders = useCallback(
    () => portfolioAuthHeaders(userId),
    [userId]
  );

  return {
    userId,
    isAuthenticated,
    loading,
    requireAuth,
    authHeaders,
  };
}
